import type { PatientSidebarCounts } from "@/types/patient-sidebar";

import { requestData } from "@/api/api-config";

export async function getPatientSidebarCounts(
  patientId: string,
  includeCancelled: boolean | null = null,
): Promise<PatientSidebarCounts | null> {
  return await requestData<PatientSidebarCounts>(
    `user/patient/${patientId}/sidebar-counts`,
    "get",
    { searchParams: { includeCancelled: includeCancelled?.toString() } },
  );
}
